import Drawer from '@commons/Drawer';
import React from 'react';

import GeneratePublicApiForm from './PublicApiForm';

import { API_KEY_FORM_MODE_ENUM } from './utils';

export const PublicApiDrawer = ({
  displayGenerateApiKeyDrawer = false,
  onClose,
  onSuccess,
  selectedKey = null,
}) => {
  const mode = selectedKey ? API_KEY_FORM_MODE_ENUM.UPDATE : API_KEY_FORM_MODE_ENUM.CREATE;

  return (
    <Drawer
      customWidth="520px"
      isOpened={displayGenerateApiKeyDrawer}
      overlayOpacity={'1'}
      onClick={onClose}
    >
      <GeneratePublicApiForm
        isOpened={displayGenerateApiKeyDrawer}
        mode={mode}
        selectedKey={selectedKey}
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </Drawer>
  );
};
